<template>
  <div @click="goBack()" class="cursor-pointer hidden hidden md:inline-block underline">
    <svg xmlns="http://www.w3.org/2000/svg" class="inline-block stroke-current fill-current mr-3" width="23.062" height="8.103" viewBox="0 0 23.062 8.103"><g transform="translate(-179.144 -266.587)"><line x2="18.91" transform="translate(183.296 270.713)" stroke-miterlimit="10" stroke-width="1"/><path d="M183.3,267.685v5.906l-3.391-2.953Z" stroke-miterlimit="10" stroke-width="1"/></g></svg>
          {{$t('shared.strings.backLabel')}}
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$store.commit('reset');
      this.$router.back();
    },
  },
};
</script>

<style>

</style>
